import { render, staticRenderFns } from "./Gauge.vue?vue&type=template&id=2172d11e&"
import script from "./Gauge.vue?vue&type=script&lang=js&"
export * from "./Gauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2172d11e')) {
      api.createRecord('2172d11e', component.options)
    } else {
      api.reload('2172d11e', component.options)
    }
    module.hot.accept("./Gauge.vue?vue&type=template&id=2172d11e&", function () {
      api.rerender('2172d11e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/charts/Gauge.vue"
export default component.exports